const images = [
  {
    thumb: require("../../../assets/collection/nobilium/antracyt.jpg"),
    src: require("../../../assets/collection/nobilium/antracyt.jpg"),
    caption: "Antracyt",
    srcset: require("../../../assets/collection/nobilium/antracyt.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/nobilium/ardente.jpg"),
    src: require("../../../assets/collection/nobilium/ardente.jpg"),
    caption: "Adrente",
    srcset: require("../../../assets/collection/nobilium/ardente.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/nobilium/czar_lawy.jpg"),
    src: require("../../../assets/collection/nobilium/czar_lawy.jpg"),
    caption: "Czar Lawy",
    srcset: require("../../../assets/collection/nobilium/czar_lawy.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/nobilium/dab_koral.jpg"),
    src: require("../../../assets/collection/nobilium/dab_koral.jpg"),
    caption: "Dąb Koral",
    srcset: require("../../../assets/collection/nobilium/dab_koral.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/nobilium/dab_lea.jpg"),
    src: require("../../../assets/collection/nobilium/dab_lea.jpg"),
    caption: "Dąb Lea",
    srcset: require("../../../assets/collection/nobilium/dab_lea.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/nobilium/zimowy_poranek_plus.jpg"),
    src: require("../../../assets/collection/nobilium/zimowy_poranek_plus.jpg"),
    caption: "Zimowy Poranek Plus",
    srcset: require("../../../assets/collection/nobilium/zimowy_poranek_plus.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/nobilium/dab_lira.jpg"),
    src: require("../../../assets/collection/nobilium/dab_lira.jpg"),
    caption: "Dąb Lira",
    srcset: require("../../../assets/collection/nobilium/dab_lira.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/nobilium/dab_mars.jpg"),
    src: require("../../../assets/collection/nobilium/dab_mars.jpg"),
    caption: "Dąb Mars",
    srcset: require("../../../assets/collection/nobilium/dab_mars.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/nobilium/dab_opal.jpg"),
    src: require("../../../assets/collection/nobilium/dab_opal.jpg"),
    caption: "Dąb Opal",
    srcset: require("../../../assets/collection/nobilium/dab_opal.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/nobilium/dab_sara.jpg"),
    src: require("../../../assets/collection/nobilium/dab_sara.jpg"),
    caption: "Dąb Sara",
    srcset: require("../../../assets/collection/nobilium/dab_sara.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/nobilium/divina.jpg"),
    src: require("../../../assets/collection/nobilium/divina.jpg"),
    caption: "Divina",
    srcset: require("../../../assets/collection/nobilium/divina.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/nobilium/ebane_nero.jpg"),
    src: require("../../../assets/collection/nobilium/ebane_nero.jpg"),
    caption: "Ebane Nero",
    srcset: require("../../../assets/collection/nobilium/ebane_nero.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/nobilium/zimowy_poranek.jpg"),
    src: require("../../../assets/collection/nobilium/zimowy_poranek.jpg"),
    caption: "Zimowy Poranek",
    srcset: require("../../../assets/collection/nobilium/zimowy_poranek.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/nobilium/nordycki_i.jpg"),
    src: require("../../../assets/collection/nobilium/nordycki_i.jpg"),
    caption: "Nordycki I",
    srcset: require("../../../assets/collection/nobilium/nordycki_i.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/nobilium/nordycki_ii.jpg"),
    src: require("../../../assets/collection/nobilium/nordycki_ii.jpg"),
    caption: "Nordycki II",
    srcset: require("../../../assets/collection/nobilium/nordycki_ii.jpg"),
    description: ""
  }
];

export default images;
